module.exports = __webpack_public_path__ + "static/media/country_gy.a490373b.webp";